<app-mixit-x509-banner/>
@if (alarm$ | async) {
  <app-alarm-bar [alarm]="alarm$"> </app-alarm-bar>
}

<app-schematics-tile
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [showShadow]="false"
  [dataPoints$]="dataPoints$"
  >
</app-schematics-tile>

@if (pumpDevice$ | async) {
  <app-pump-status-tile
    [application]="application"
    [installation$]="installation$"
    [pumpType$]="pumpType$"
    [pumpDevice$]="pumpDevice$"
    [pumpOptions]="pumpOptions$ | async"
    >
  </app-pump-status-tile>
}
